/* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */
import React from 'react';
export default (function (_ref) {
  var size = _ref.size,
    primaryColor = _ref.primaryColor,
    secondaryColor = _ref.secondaryColor;
  return /*#__PURE__*/React.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 42 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0069 1.14541C20.241 0.436192 21.759 0.436193 22.9931 1.14541L39.9931 10.9152C41.2346 11.6287 42 12.9514 42 14.3833V33.891C42 35.3229 41.2346 36.6456 39.9931 37.3591L22.9931 47.1289C21.759 47.8381 20.241 47.8381 19.0069 47.1289L2.00691 37.3591C0.765414 36.6456 0 35.3229 0 33.891V14.3833C0 12.9514 0.765415 11.6287 2.00691 10.9152L19.0069 1.14541Z",
    fill: primaryColor
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7095_35871",
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: "42",
    height: "48"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0069 1.14541C20.241 0.436192 21.759 0.436193 22.9931 1.14541L39.9931 10.9152C41.2346 11.6287 42 12.9514 42 14.3833V33.891C42 35.3229 41.2346 36.6456 39.9931 37.3591L22.9931 47.1289C21.759 47.8381 20.241 47.8381 19.0069 47.1289L2.00691 37.3591C0.765414 36.6456 0 35.3229 0 33.891V14.3833C0 12.9514 0.765415 11.6287 2.00691 10.9152L19.0069 1.14541Z",
    fill: primaryColor
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7095_35871)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.0672 6.71876C25.3431 2.95696 20.5959 3.71388 17.4568 4.31657C15.7916 3.78529 8.29655 8.02982 12.9638 6.90157C14.969 5.24204 21.7699 4.42513 25.5174 6.01325C26.6142 5.14778 33.6494 9.66079 31.0644 6.71876H31.0672Z",
    fill: secondaryColor
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9625 9.38656C25.7374 7.36142 22.4669 7.57567 21.1187 7.73562C22.2041 7.07866 19.3163 7.38142 18.8479 7.71561C19.3049 7.68704 19.065 7.98126 18.6851 8.01268C18.5651 7.22433 13.5494 9.07236 14.9148 10.0264C15.5232 9.70932 15.8259 9.99212 15.8802 9.36372C16.1858 10.1092 16.8113 9.0438 17.0198 8.96097C17.4654 9.10664 17.454 9.28659 18.0339 8.85528C18.8108 8.85528 19.9219 9.06952 21.2272 8.82673C23.0467 8.76674 24.035 9.32945 25.5403 9.47512C26.1744 9.70934 29.3421 11.2061 27.9682 9.39228L27.9625 9.38656Z",
    fill: secondaryColor
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2261 12.2772C24.3349 11.526 23.2095 11.0833 21.6328 11.1832C22.2955 11.7345 21.6757 11.7202 21.253 11.4546C22.0927 10.849 19.4506 10.9976 20.1305 11.5174C19.9534 11.6431 19.7562 11.566 19.8905 11.4232C18.9051 10.9747 15.8916 13.1684 18.3424 12.6943C18.2281 12.3058 18.6623 13.2541 18.9851 12.3258C19.3621 12.5828 19.2421 12.7228 19.5734 12.3658C19.9219 12.3886 20.6074 12.8171 21.3072 12.5429C22.3041 12.3086 22.6669 13.1827 23.4152 12.6714C23.8608 13.0541 25.9859 13.4569 25.2204 12.2743L25.2261 12.2772Z",
    fill: secondaryColor
  })), /*#__PURE__*/React.createElement("path", {
    d: "M33.2237 14.725H8.77625V30.7332H33.2237V14.725Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5669 32.925V35.6463H14.4331V32.925H18.8081V28.0425H23.1919V32.925H27.5669Z",
    fill: "#101214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1919 28.0425H18.8081V30.7375H23.1919V28.0425Z",
    fill: primaryColor
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 26.5288C23.0973 26.5288 24.7975 24.8286 24.7975 22.7313C24.7975 20.634 23.0973 18.9338 21 18.9338C18.9027 18.9338 17.2025 20.634 17.2025 22.7313C17.2025 24.8286 18.9027 26.5288 21 26.5288Z",
    fill: primaryColor
  }));
});